export default "__VITE_ASSET__CiUZEcUm__"